export default "__VITE_ASSET__djYfC$lx__"